import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbdd3464"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content h-100 w-100" }
const _hoisted_2 = { class: "header level" }
const _hoisted_3 = { class: "brand-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content center" }
const _hoisted_6 = { class: "box p-5 w-40" }
const _hoisted_7 = { class: "box-content" }
const _hoisted_8 = { class: "box-content-description mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-alert is-size-1 has-text-danger" })
], -1 /* HOISTED */))
const _hoisted_10 = { class: "contact-support" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-account-plus is-size-3 m-2" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "brand",
          src: _ctx.avoltaConnectLogo
        }, null, 8 /* PROPS */, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('wrong_configuration.account_not_linked')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('wrong_configuration.contact_support_to_link_account')), 1 /* TEXT */)
            ])
          ]),
          _createVNode(_component_n_form, {
            ref: "form",
            model: _ctx.form,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_form_item, {
                path: "company",
                label: _ctx.$t('wrong_configuration.form.company.label')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.form.company,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.company) = $event)),
                    placeholder: _ctx.$t('wrong_configuration.form.company.label')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, {
                path: "email",
                label: _ctx.$t('wrong_configuration.form.email.label')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.form.email,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                    placeholder: _ctx.$t('wrong_configuration.form.email.label')
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, {
                path: "message",
                label: _ctx.$t('wrong_configuration.form.message.label')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    value: _ctx.form.message,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.message) = $event)),
                    type: "textarea",
                    placeholder: _ctx.$t('wrong_configuration.form.message.placeholder'),
                    resizable: false
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"]),
          _createVNode(_component_n_button, {
            class: "w-100",
            size: "large",
            type: "success",
            round: "",
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('wrong-configuration.submit')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ])
    ])
  ]))
}